<app-header icon="fas fa-images" text="Bilder" sub=""></app-header>
<p-divider />
@if (store.asArray(); as images) {
  @if (images.length > 0) {
    @if (images.length >= 15) {
      <app-alert severity="info" header="Limit erreicht" [canToggle]="false">
        <p>
          Sie können maximal 15 Bilder anlegen. Um weitere Bilder anzulegen,
          löschen oder aktualisieren Sie bitte ungenutzte Bilder.
        </p>
      </app-alert>
    }
    <p-table
      #imageTable
      [globalFilterFields]="['title']"
      [loading]="loading"
      [value]="images">
      <ng-template pTemplate="caption">
        <app-table-list-caption
          [disableAddButton]="images.length >= 15"
          [searchWord]="searchWord"
          (clearTable)="clear(imageTable)"
          (search)="
            imageTable.filterGlobal($event, 'contains')
          "></app-table-list-caption>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th></th>
          <th>Bild</th>
          <th>Aktionen</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-image>
        <tr>
          <td class="w-6rem">
            <div class="p-card p-0 w-6rem">
              <img
                [ngSrc]="getSrc(image.src)"
                [alt]="image.src"
                fill
                priority
                style="
                  position: static;
                  object-fit: cover;
                  object-position: 50% 50%;
                " />
            </div>
          </td>
          <td>
            <span class="flex align-items-center gap-3">
              {{ image.title }}</span
            >
          </td>
          <td>
            <app-table-list-actions
              [item]="image"
              (confirm)="confirm($event, image, image.title)">
            </app-table-list-actions>
          </td>
        </tr>
      </ng-template>
    </p-table>
  } @else {
    <app-alert header="Keine Bilder gefunden" [canToggle]="false">
      <p>
        Nutzen Sie Bilder, um Ihren Teasern einen eigenen Touch zu verleihen.
      </p>
      <p>
        <a [routerLink]="[{ outlets: { bearbeiten: 'neu' } }]"
          >Ihr erstes Bild anlegen.</a
        >
      </p>
    </app-alert>
  }
}

<p-sidebar
  (onHide)="onOverlayClose()"
  position="right"
  [modal]="false"
  [styleClass]="'w-9'"
  [visible]="editFormOverlay">
  <ng-template pTemplate="header">
    <app-header
      [icon]="editFormOverlayIcon"
      [text]="editFormOverlayHeader"></app-header
  ></ng-template>

  <ng-container *ngIf="editFormOverlay">
    <router-outlet name="bearbeiten"></router-outlet>
  </ng-container>
</p-sidebar>
<app-mask [visible]="editFormOverlay" (click)="onOverlayClose()"></app-mask>
